import {Component, EventEmitter, OnInit, Output, TemplateRef, ViewChild} from '@angular/core';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {SergasDeviceService} from '../sergas-device.service';
import {SergasDevice} from '../sergasDevice';
import {I18NService} from '../../../../shared/i18n/i18n.service';
import {IPlaceValuelistService} from '../../../../iPlace/iPlace-valuelist.service';
import {SectionService} from '../../../section/Section.service';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {HardwareDeviceService} from '../hardware-device.service';
import {BsDatepickerConfig} from 'ngx-bootstrap/datepicker';
import {GadgetService} from '../../../gadget/Gadget.service';
import {Section} from '../../../section/Section';
import {HardwareSensorService} from '../hardware-sensor.service';
import {HardwareDevice} from '../hardwareDevice';
import {NgForm, NgModel} from '@angular/forms';
import {SergasSensor} from '../sergasSensor';
import * as uuid from 'uuid';
import {NotificationsService} from 'angular2-notifications';
import {HardwareSensor} from '../hardwareSensor';

@Component({
  selector: 'app-monitored-equipment-detail',
  templateUrl: './monitored-equipment-detail.component.html',
  styleUrls: ['./monitored-equipment-detail.component.css']
})
export class MonitoredEquipmentDetailComponent implements OnInit {

  isLoading = false;
  sergasDeviceId: string;

  sergasDevice: SergasDevice | any = {};

  dropdowniPlaceList:any = [];
  dropdowniPlaceSettings:any = {};
  selectediPlace: any;

  iPlaceList:any[] = [];
  iPlaceMap:any[];

  dropdownSectionList:any = [];
  dropdownSectionSettings:any = {};
  sectionList:any[] = [];
  sectionMap:any[];
  sections: any[] = [];
  sectionsMap: any = {};
  currentSectionId: string;

  sectionTree: any;
  @Output() public sectionSelected: EventEmitter<any> = new EventEmitter();

  dropdownGadgetList:any = [];
  dropdownGadgetSettings:any = {};
  gadgets: any[] = [];

  private markForDeleteTimeouts: any[] = [];
  modalRef: BsModalRef;

  hardwareDevicesHistoric: any[] = [];
  @ViewChild('hardwareDevicesTemplate', { static: true })
  private hardwareDevicesTempRef: TemplateRef<any>;
  isLoadingHardwareDevices = true;

  currentSergasSensor: any;
  hardwareSensorsHistoric: any[] = [];
  @ViewChild('hardwareSensorsTemplate', { static: true })
  private hardwareSensorsTempRef: TemplateRef<any>;
  isLoadingHardwareSensors = true;

  @ViewChild('confirmGoBackTemplate', { static: true })
  private confirmGoBackTempRef: TemplateRef<any>;

  bsConfig: Partial<BsDatepickerConfig>;
  bsConfigCalibration: Partial<BsDatepickerConfig>;

  @ViewChild('detailForm', { static: false }) detailForm: NgForm;
  @ViewChild('sergasSensorsForm', { static: false }) sergasSensorsForm: NgForm;
  @ViewChild('hardwareDevicesForm', { static: false }) hardwareDevicesForm: NgForm;

  modifiedHistoric = false;
  modifiedHardwareDevices = false;
  modifiedHardwareSensors = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private sergasDeviceService: SergasDeviceService,
    private hardwareDeviceService: HardwareDeviceService,
    private hardwareSensorService: HardwareSensorService,
    private i18nService: I18NService,
    private iPlaceValuelistService: IPlaceValuelistService,
    private sectionService: SectionService,
    private gadgetService: GadgetService,
    private modalService: BsModalService,
    private notificationService: NotificationsService
  ) {

    if ( (<any>Object).values(this.iPlaceValuelistService.getValuelist()).length ) {
      this.iPlaceList = (<any>Object).values(this.iPlaceValuelistService.getValuelist())
        .sort((a:any,b:any) => a.iPlaceName.localeCompare(b.iPlaceName));
      this.iPlaceMap = this.iPlaceList.reduce((previous:any, current:any) => {
        previous[current.id] = current;
        return previous;
      }, {})
      this.dropdowniPlaceList = this.iPlaceList;
    } else {
      this.iPlaceValuelistService.reload()
        .then( () => {
          this.iPlaceList = (<any>Object).values(this.iPlaceValuelistService.getValuelist())
            .sort((a:any,b:any) => a.iPlaceName.localeCompare(b.iPlaceName));
          this.iPlaceMap = this.iPlaceList.reduce((previous:any, current:any) => {
            previous[current.id] = current;
            return previous;
          }, {});
          this.dropdowniPlaceList = this.iPlaceList;
        })
    }

    this.dropdowniPlaceSettings = {
      singleSelection: true,
      enableCheckAll: false,
      enableFilterSelectAll: false,
      primaryKey: 'idiPlace',
      labelKey: 'iPlaceName',
      selectAllText: i18nService.get("selectAll"),
      unSelectAllText: i18nService.get("unselectAll"),
      filterSelectAllText: i18nService.get("selectAllFiltered"),
      filterUnSelectAllText: i18nService.get("unselectAllFiltered"),
      noDataLabel: i18nService.get("noResults"),
      text: i18nService.get("selectiPlaces"),
      searchPlaceholderText: i18nService.get("search"),
      badgeShowLimit: 2,
      enableSearchFilter: true,
      groupBy: null,
      classes: "form-angular2-multiselect",
      autoPosition: false
    };

    this.dropdownGadgetSettings = {
      singleSelection: true,
      enableCheckAll: false,
      enableFilterSelectAll: false,
      primaryKey: 'gadgetId',
      labelKey: 'elementName',
      selectAllText: i18nService.get("selectAll"),
      unSelectAllText: i18nService.get("unselectAll"),
      filterSelectAllText: i18nService.get("selectAllFiltered"),
      filterUnSelectAllText: i18nService.get("unselectAllFiltered"),
      noDataLabel: i18nService.get("noResults"),
      text: i18nService.get("selectGadget"),
      searchPlaceholderText: i18nService.get("search"),
      badgeShowLimit: 2,
      enableSearchFilter: true,
      groupBy: null,
      classes: "form-angular2-multiselect",
      autoPosition: false
    };

    this.bsConfig = Object.assign({}, {containerClass: "theme-custom", showWeekNumbers: false});
    this.bsConfigCalibration = Object.assign({}, {containerClass: "theme-custom calibration-date", showWeekNumbers: false});

  }

  ngOnInit() {
    this.route.params.subscribe((params: Params) => {
      this.isLoading = true;
      this.sergasDeviceId = params["sergasDeviceId"];

      if(this.sergasDeviceId != "new") {
        this.sergasDeviceService.getSergasDevice(this.sergasDeviceId).then(response => {
          this.parseSergasDevice(response);
        });
      } else {
        this.sergasDevice = new SergasDevice(
          uuid.v4(),
          '',
          '',
          '',
          '',
          '',
          new Date(),
          localStorage.getItem('user_id'),
          null,
          null,
          [],
          []);
        this.isLoading = false;
      }
    });
  }

  private getSergasDeviceiPlace(){
    if(this.iPlaceMap){
      this.sergasDevice['iPlace'] = [this.iPlaceMap[this.sergasDevice['iPlaceId']]];
    } else{
      setTimeout(this.getSergasDeviceiPlace, 100);
    }
  }

  private parseSergasDevice(sergasDevice) {
    this.sergasDevice = sergasDevice;
    this.getSergasDeviceiPlace();
    this.getSectionsByiPlace(this.sergasDevice['iPlaceId']);
    this.sergasDevice.hardwareDevices.forEach(hardwareDevice => {
      hardwareDevice.installedDate = new Date(hardwareDevice.installedDate);
    });
    this.sergasDevice.sergasSensors.forEach(sergasSensor => {
      sergasSensor.hardwareSensors.forEach(hardwareSensor => {
        hardwareSensor.calibrationDate = new Date(hardwareSensor.calibrationDate);
        hardwareSensor.installedDate = new Date(hardwareSensor.installedDate);
      })
    })
  }

  private getSectionTree(sections:Section[]) {
    let sectionsMap = sections.reduce(function(map, section) {
      map[section.sectionId] = section;
      section['children'] = [];
      section['value'] = section.name;
      return map;
    }, {});

    sections.forEach(section => {
      if ( section.parentSectionId ) {
        let parent = sectionsMap[section.parentSectionId];
        if ( parent ) {
          parent.children.push(section);
        }
      }
    });
    sections.forEach((section:any) => {
      section.children = section.children.sort( (a:any,b:any) => a.name.localeCompare(b.name))
    });
    return sections[0];
  }

  private getSectionsByiPlace(iPlaceId) {

    if(iPlaceId != null) {
      this.sectionService.get(iPlaceId).then(sections => {
        this.sections = sections
          .sort((a, b) => a.localSectionId < b.localSectionId ? -1 : a.localSectionId > b.localSectionId ? 1 : 0);
        this.sectionMap = this.sections.reduce((previous:any, current:any) => {
          previous[current.id] = current;
          return previous;
        }, {});
        this.sectionTree = this.getSectionTree(this.sections);
        if(this.sergasDeviceId != "new" && this.sergasDevice.sectionId) {
          this.sergasDevice['section'] = [this.sectionMap[this.sergasDevice['sectionId']]];
          this.getGadgetsBySection(iPlaceId, this.sergasDevice['sectionId']);
        }
      });
    } else {
      this.onSectionDeSelect();
      this.sections = [];
      this.sectionMap = [];
      this.sectionTree = null;
      this.isLoading = false;
    }
  }

  private getGadgetsBySection(iPlaceId, sectionId) {
    this.gadgetService.getBySection(iPlaceId, sectionId).then(response => {
      this.gadgets = response;
      this.dropdownGadgetList = this.gadgets;

      this.sergasDevice['sergasSensors'].forEach(sergasSensor => {
        let gadget = this.gadgets.find(gadget => gadget.gadgetId == sergasSensor['gadgetId'] && gadget.elementId == sergasSensor['elementId']);
        sergasSensor['gadget'] = gadget ? [gadget] : [];
      });
      this.isLoading = false;
    })
  }

  goBack() {
    if(this.detailForm.dirty || (this.sergasSensorsForm && this.sergasSensorsForm.dirty) || this.modifiedHistoric) {
      this.modalRef = this.modalService.show(this.confirmGoBackTempRef, { class: 'confirm-go-back' });
    } else {
      this.confirmGoBack();
    }
  }

  confirmGoBack() {
    this.hide();
    this.router.navigate(['cloud/monitored-equipment']);
  }

  saveSergasDevice() {
    if(this.detailForm.valid && (this.sergasSensorsForm ? this.sergasSensorsForm.valid : true)) {
      this.isLoading = true;
      if(this.sergasDeviceId != "new") {
        if(this.detailForm.dirty) {
          this.sergasDevice.modified = new Date();
          this.sergasDevice.modifiedBy = localStorage.getItem("user_id");
        }
        this.sergasDeviceService.updateSergasDevice(this.sergasDevice)
          .then(sergasDevice => {
            this.parseSergasDevice(sergasDevice);
            this.router.navigate(["cloud/monitored-equipment/", this.sergasDevice.sergasDeviceId]);
            this.isLoading = false;
            this.modifiedHistoric = false;
            this.notificationService.success(
              this.i18nService.get("success"),
              this.i18nService.get("dataSaved")
            );
          })
          .catch( error => {
            this.isLoading = false;
            this.notificationService.error(
              this.i18nService.get("error") ,
              this.i18nService.get("cantSaveData")
            );
          })
      } else {
        this.sergasDeviceService.createSergasDevice(this.sergasDevice)
          .then(sergasDevice => {
            this.parseSergasDevice(sergasDevice);
            this.router.navigate(["cloud/monitored-equipment/", this.sergasDevice.sergasDeviceId]);
            this.isLoading = false;
            this.modifiedHistoric = false;
            this.notificationService.success(
              this.i18nService.get("success"),
              this.i18nService.get("dataSaved")
            );
          })
          .catch( error => {
            this.isLoading = false;
            this.notificationService.error(
              this.i18nService.get("error") ,
              this.i18nService.get("cantSaveData")
            );
          })
        this.isLoading = false;
      }
    } else {
      Object.keys(this.detailForm.controls).forEach(controlKey => {
        this.detailForm.controls[controlKey].markAsDirty();
      });
      if(this.sergasSensorsForm) {
        Object.keys(this.sergasSensorsForm.controls).forEach(controlKey => {
          this.sergasSensorsForm.controls[controlKey].markAsDirty();
        });
      }
    }
  }

  oniPlaceSelect(item: any) {
    this.detailForm.controls['iPlace'].markAsDirty();
    this.detailForm.controls['iPlace'].markAsTouched();
    this.sergasDevice.iPlace = [item];
    this.sergasDevice.iPlaceId = item.idiPlace;
    this.onSectionDeSelect();
    this.getSectionsByiPlace(item.idiPlace);
    this.deSelectAllGadgets();
  }

  oniPlaceDeSelect(item: any) {
    this.detailForm.controls['iPlace'].markAsDirty();
    this.detailForm.controls['iPlace'].markAsTouched();
    this.sergasDevice.iPlace = [];
    this.sergasDevice.iPlaceId = null;
    this.getSectionsByiPlace(null);
    this.deSelectAllGadgets();
  }

  onSectionSelect(e:any){
    this.detailForm.controls['section'].markAsDirty();
    this.detailForm.controls['section'].markAsTouched();
    this.sergasDevice.section = [e];
    this.sergasDevice.sectionId = e.sectionId;
    this.sergasDevice.sectionName = e.name;
    this.deSelectAllGadgets();
    this.getGadgetsBySection(e.iPlaceId, e.sectionId);
  }

  onSectionDeSelect(){
    if(this.sergasDevice.sectionId) {
      this.detailForm.controls['section'].markAsDirty();
      this.detailForm.controls['section'].markAsTouched();
      this.sergasDevice.section = [];
      this.sergasDevice.sectionId = null;
      this.sergasDevice.sectionName = null;
    }
  }

  deSelectAllGadgets() {
    this.sergasDevice.sergasSensors.forEach(sergasSensor => {
      this.sergasSensorsForm.controls[sergasSensor.sergasSensorId + 'gadget'].markAsTouched();
      this.sergasSensorsForm.controls[sergasSensor.sergasSensorId + 'gadget'].markAsDirty();
      sergasSensor.gadget = [];
      sergasSensor.gadgetId = null;
      sergasSensor.elementId = null;
    })
  }

  onGadgetSelect(item: any, row: any, gadget: NgModel) {
    gadget.control.markAsTouched();
    row.gadget = [item];
    row.gadgetId = item.gadgetId;
    row.elementId = item.elementId;
  }

  onGadgetDeSelect(item: any, row: any, gadget: NgModel) {
    gadget.control.markAsDirty();
    gadget.control.markAsTouched();
    row.gadget = [];
    row.gadgetId = null;
    row.elementId = null;
  }

  openHardwareDevicesModal() {
    this.modalRef = this.modalService.show(this.hardwareDevicesTempRef);

    this.hardwareDevicesHistoric = [];
    this.sergasDevice.hardwareDevices.forEach(val => this.hardwareDevicesHistoric.push(Object.assign({}, val)));

    this.isLoadingHardwareDevices = false;
  }

  addNewHardwareDevice(hardwareDevicesForm: NgForm) {
    let newHardwareDevice = new HardwareDevice(uuid.v4(),
      '',
      '',
      '',
      '',
      new Date(),
      new Date(),
      localStorage.getItem('user_id'),
      null,
      null,
      this.sergasDevice.sergasDeviceId);

    newHardwareDevice['isNew'] = true;

    Object.values(hardwareDevicesForm.controls).forEach(control => control.markAsPristine());
    this.hardwareDevicesHistoric.push(newHardwareDevice);
    this.hardwareDevicesHistoric = [...this.hardwareDevicesHistoric];
  }

  saveHardwareDevices(hardwareDevicesForm: NgForm) {
    if(hardwareDevicesForm.valid) {
      Object.keys(hardwareDevicesForm.controls).forEach(controlKey => {
        if(hardwareDevicesForm.controls[controlKey].dirty) {
          let hardwareDeviceId = controlKey.slice(0,36);
          let modifiedHd = this.hardwareDevicesHistoric.find(hd => hd.hardwareDeviceId == hardwareDeviceId);
          if(!modifiedHd.hasOwnProperty('isNew') || modifiedHd['isNew'] != true) {
            modifiedHd['modified'] = new Date();
            modifiedHd['modifiedBy'] = localStorage.getItem("user_id");
          }
          hardwareDevicesForm.controls[controlKey].markAsPristine();
        }
      })
      this.sergasDevice.hardwareDevices = this.hardwareDevicesHistoric;
      this.sergasDevice.hardwareDevices.sort((a, b) => {
        return b.installedDate - a.installedDate;
      });
      this.modifiedHardwareDevices = false;
      this.modifiedHistoric = true;
      this.modalService.hide(1);
    } else {
      Object.keys(hardwareDevicesForm.controls).forEach(controlKey => {
        hardwareDevicesForm.controls[controlKey].markAsDirty();
      });
    }
  }

  deleteHardwareDevice(hardwareDevice) {
    const index = this.hardwareDevicesHistoric.indexOf(hardwareDevice, 0);
    if (index > -1) {
      this.hardwareDevicesHistoric.splice(index, 1);
      this.hardwareDevicesHistoric = [...this.hardwareDevicesHistoric];
    }
    this.modifiedHardwareDevices = true;
  }

  addNewSergasSensor() {
    this.sergasDevice.sergasSensors.push(new SergasSensor(uuid.v4(),'','','',this.sergasDevice.sergasDeviceId,[]));
    this.sergasDevice.sergasSensors = [...this.sergasDevice.sergasSensors];
  }

  markForDelete(row: any){
    row.confirmDelete = true;
    this.markForDeleteTimeouts[row.rowId] = setTimeout(()=> {
      row.confirmDelete = false;
      row.confirmDeleteTimer = 0;
    }, 5000);
  }

  deleteSergasSensor(sergasSensor) {
    const index = this.sergasDevice.sergasSensors.indexOf(sergasSensor, 0);
    if (index > -1) {
      this.sergasDevice.sergasSensors.splice(index, 1);
      this.sergasDevice.sergasSensors = [...this.sergasDevice.sergasSensors];
    }
    this.modifiedHistoric = true;
  }

  openHardwareSensorsModal(sergasSensor) {
    this.modalRef = this.modalService.show(this.hardwareSensorsTempRef);

    this.currentSergasSensor = this.sergasDevice.sergasSensors.find(ss => ss.sergasSensorId == sergasSensor.sergasSensorId);
    this.hardwareSensorsHistoric = [];
    this.currentSergasSensor.hardwareSensors.forEach(val => this.hardwareSensorsHistoric.push(Object.assign({}, val)));

    this.isLoadingHardwareSensors = false;
  }

  addNewHardwareSensor(hardwareSensorsForm: NgForm) {
    let newHardwareSensor = new HardwareSensor(uuid.v4(),
      '',
      '',
      new Date(),
      '',
      '',
      new Date(),
      new Date(),
      localStorage.getItem('user_id'),
      null,
      null,
      this.currentSergasSensor.sergasSensorId);

    newHardwareSensor['isNew'] = true;

    Object.values(hardwareSensorsForm.controls).forEach(control => control.markAsPristine());
    this.hardwareSensorsHistoric.push(newHardwareSensor);
    this.hardwareSensorsHistoric = [...this.hardwareSensorsHistoric];
  }

  saveHardwareSensors(hardwareSensorsForm: NgForm) {
    if(hardwareSensorsForm.valid) {
      Object.keys(hardwareSensorsForm.controls).forEach(controlKey => {
        if(hardwareSensorsForm.controls[controlKey].dirty) {
          let hardwareSensorId = controlKey.slice(0,36);
          let modifiedHs = this.hardwareSensorsHistoric.find(hs => hs.hardwareSensorId == hardwareSensorId);
          if(!modifiedHs.hasOwnProperty('isNew') || modifiedHs['isNew'] != true) {
            modifiedHs['modified'] = new Date();
            modifiedHs['modifiedBy'] = localStorage.getItem("user_id");
          }
          hardwareSensorsForm.controls[controlKey].markAsPristine();
        }
      })
      this.currentSergasSensor.hardwareSensors = this.hardwareSensorsHistoric;
      this.currentSergasSensor.hardwareSensors.sort((a, b) => {
        return b.installedDate - a.installedDate;
      });
      this.modifiedHardwareSensors = false;
      this.modifiedHistoric = true;
      this.modalService.hide(1);
    } else {
      Object.keys(hardwareSensorsForm.controls).forEach(controlKey => {
        hardwareSensorsForm.controls[controlKey].markAsDirty();
      });
    }
  }

  deleteHardwareSensor(hardwareSensor) {
    const index = this.hardwareSensorsHistoric.indexOf(hardwareSensor, 0);
    if (index > -1) {
      this.hardwareSensorsHistoric.splice(index, 1);
      this.hardwareSensorsHistoric = [...this.hardwareSensorsHistoric];
    }
    this.modifiedHardwareSensors = true;
  }

  deleteSergasDevice(){
    this.sergasDeviceService.deleteSergasDevice(this.sergasDevice)
      .then(() => {
        this.router.navigate(['cloud/monitored-equipment']);
        this.notificationService.success(
          this.i18nService.get("success"),
          this.i18nService.get("dataSaved")
        );
    })
      .catch( error => {
        this.notificationService.error(
          this.i18nService.get("error") ,
          this.i18nService.get("cantSaveData")
        );
      })
  }

  hide() {
    this.modalService.hide(1);
  }

}
